import '../style.scss'
import { useState } from "react";
import { RiCloseFill } from "react-icons/ri"
import { SidePopupContainer, FlexColumn, AppSpan, Button, FlexRow, CustomContainer, AppText, Form, GridContainer, CodeLabel, AppLink } from "src/style"
import { handleTypeNumberControl } from "src/utils/utility"
import { useNotifier } from "react-pop-notifier"

export const TxCode: React.FC<any> = ({onCodeChange, next, close}) => {
    const {notifier} = useNotifier()
    const [code, setCode] = useState('')

    const handleCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length < 5) {
            setCode(e.target.value)
            if (e.target.value.length === 4) onCodeChange(e.target.value)
        }
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (code.length != 4) return notifier.show('Kindly provide a valid code', 'Validation Response')
        if (next) {
            await next()
        }
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Pay with Card</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#667085'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <CustomContainer topMargin="2">
                    <AppText textSize="1.6" color="#101828" fontWeight="300">
                        We've sent a code to olivia@gmail.com
                    </AppText>
                    <Form topMargin="2" onSubmit={handleProceed}>
                        <GridContainer>
                            <FlexRow 
                                width="auto" sizeUnit="" gap='1.4'
                            >
                                <input 
                                    className='display-hidden' id='code' 
                                    name="code" value={code}
                                    onChange={handleCode} 
                                    onKeyDown={handleTypeNumberControl}
                                    onKeyUp={handleTypeNumberControl}
                                    autoFocus={true} autoComplete="off"
                                />
                                <CodeLabel style={{paddingTop: '1rem'}} className={`${code.length === 0 ? 'active-code-box' : ''}`} htmlFor='code' >{code[0] ? '*' : ''}</CodeLabel>
                                <CodeLabel style={{paddingTop: '1rem'}} className={`${code.length === 1 ? 'active-code-box' : ''}`} htmlFor='code' >{code[1] ? '*' : ''}</CodeLabel>
                                <CodeLabel style={{paddingTop: '1rem'}} className={`${code.length === 2 ? 'active-code-box' : ''}`} htmlFor='code' >{code[2] ? '*' : ''}</CodeLabel>
                                <CodeLabel style={{paddingTop: '1rem'}} className={`${code.length >= 3 ? 'active-code-box' : ''}`} htmlFor='code' >{code[3] ? '*' : ''}</CodeLabel>
                            </FlexRow>
                        </GridContainer>
                        <AppText fontWeight='300' align='center'>
                            Didn’t get a code? 
                            <AppLink 
                                fontWeight='300' leftPadding='0.5'
                                hoverColor='#0D968F'
                            >
                                Click to resend.
                            </AppLink>
                        </AppText>
                        <FlexRow justifyContent='flex-end' topMargin='2'>
                            <Button
                                width='5.8'
                                height='4' radius='0.8'
                                bottomMargin='1' hoverColor='#0D968F'
                                hoverBgColor='#fff' borderColor='#0D968F'
                            >
                                Pay
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </FlexColumn>
        </>
    )
}